module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-parvaldiba-7ca981b543e9337e38f38cfa626edfc3.png";